import { Select, Tooltip } from "antd";
import { useState, useEffect } from "react";
import { InfoCircleOutlined } from '@ant-design/icons';
import useFetchCurrencies from "../utils/useFetchCurrencies";
import { useSharePricePerformanceStore } from "../state/sharePricePerformanceStore";

export default function CurrencySelect(props: any) {
  const [selectedValue, setSelectedValue] = useState<string>(props.value);
  const title = "Currency"
  const text = "Select the currency you want your share price data in. We then apply the selected currency across all company share prices used in the analysis."
  const { currencyOptions } = useSharePricePerformanceStore();

  const handleMenuClick = (value: string) => {
    setSelectedValue(value);
    props.onSelect(value);
  };

  return (
    <div style={{ display: 'flex', marginBottom: '16px' }}>
      <label
        style={{
          marginRight: '16px',
          whiteSpace: 'nowrap',
          width: '140px',
          textAlign: 'left',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        {title}
        {text && (
          <Tooltip placement="top" title={text}>
            <div
              style={{
                cursor: 'pointer',
              }}
            >
              <InfoCircleOutlined style={{ cursor: 'pointer' }} />
            </div>
          </Tooltip>
        )}
      </label>
      <div className={'flex items-center justify-end w-full relative overflow-hidden'}>
        <Select
          options={currencyOptions}
          value={selectedValue}
          style={{ width: '180%' }}
          onChange={handleMenuClick}
          showSearch
          filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
        />
      </div>
    </div>
  );
}